import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import { Login } from './pages/Login';
import { Signup } from './pages/Signup';
import { Dashboard } from './pages/Dashboard';
import { UserManagement } from './pages/UserManagement';
import { Members } from './pages/Members';
import { Regions } from './pages/Regions';
import { MemberDetail } from './pages/MemberDetail';
import { LeaderDetail } from './pages/LeaderDetail';
import { RegionDetail } from './pages/RegionDetail';
import { PrayerRequests } from './pages/PrayerRequests';
import { Map } from './pages/Map';
import { Calendar } from './pages/Calendar';
import { Attendance } from './pages/Attendance';
import { AttendanceReports } from './pages/AttendanceReports';
import { Announcements } from './pages/Announcements';
import { AuditLog } from './pages/AuditLog';
import { NotFound } from './pages/NotFound';
import { Landing } from './pages/Landing';
import { BibleStudy } from './pages/BibleStudy';
import { PrivateRoute, AdminRoute, RegionalRoute } from './components/ProtectedRoute';
import { AppLayout } from './components/AppLayout';
import { getEnv } from './config';

const googleClientId = getEnv('REACT_APP_GOOGLE_CLIENT_ID');

function AppRoutes() {
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            <Route
                path="/dashboard"
                element={
                    <PrivateRoute>
                        <Dashboard />
                    </PrivateRoute>
                }
            />

            <Route
                path="/users"
                element={
                    <AdminRoute>
                        <UserManagement />
                    </AdminRoute>
                }
            />
            <Route path="/users/new" element={<AdminRoute><LeaderDetail /></AdminRoute>} />
            <Route path="/users/:id" element={<AdminRoute><LeaderDetail /></AdminRoute>} />

            <Route
                path="/regions"
                element={
                    <AdminRoute>
                        <Regions />
                    </AdminRoute>
                }
            />
            <Route path="/regions/new" element={<AdminRoute><RegionDetail /></AdminRoute>} />
            <Route path="/regions/:id" element={<AdminRoute><RegionDetail /></AdminRoute>} />

            <Route
                path="/members"
                element={
                    <PrivateRoute>
                        <Members />
                    </PrivateRoute>
                }
            />
            <Route path="/members/new" element={<PrivateRoute><MemberDetail /></PrivateRoute>} />
            <Route path="/members/:id" element={<PrivateRoute><MemberDetail /></PrivateRoute>} />

            <Route path="/prayers" element={<PrivateRoute><PrayerRequests /></PrivateRoute>} />

            <Route
                path="/map"
                element={
                    <PrivateRoute>
                        <Map />
                    </PrivateRoute>
                }
            />

            <Route
                path="/calendar"
                element={
                    <PrivateRoute>
                        <Calendar />
                    </PrivateRoute>
                }
            />

            <Route path="/announcements" element={<AdminRoute><Announcements /></AdminRoute>} />
            <Route path="/audit-log" element={<AdminRoute><AuditLog /></AdminRoute>} />

            <Route
                path="/attendance"
                element={
                    <RegionalRoute>
                        <Attendance />
                    </RegionalRoute>
                }
            />

            <Route
                path="/attendance/reports"
                element={
                    <AdminRoute>
                        <AttendanceReports />
                    </AdminRoute>
                }
            />

            <Route path="/biblestudy" element={<BibleStudy />} />
            <Route path="/" element={<Landing />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

function AppContent() {
    return (
        <Router>
            <AuthProvider>
                <AppLayout>
                    <AppRoutes />
                </AppLayout>
            </AuthProvider>
        </Router>
    );
}

function App() {
    if (googleClientId) {
        return (
            <GoogleOAuthProvider clientId={googleClientId}>
                <AppContent />
            </GoogleOAuthProvider>
        );
    }
    return <AppContent />;
}

export default App;
